module.exports = __webpack_public_path__ + "img/th.65351a6f.jpg";